import { transport } from 'config/transport';

export function callApiExportCongDoanReportForAllCongDoanMonthly(yearMonth, pdf = false) {
    return transport.get(`/trunguong/report/congdoan`, { params: { yearMonth, pdf }, responseType: 'blob' });
}
